import html2canvas from "html2canvas";
import * as DownloadJS from "downloadjs";

function lerp(start, end, progress) {
    return start + (end - start) * progress;
}
function easeOutQuad(x) {
    return 1 - (1 - x) * (1 - x);
}
function easeInOutSine(x) {
    return -(Math.cos(Math.PI * x) - 1) / 2;
}

// Index page mouse-motion parallax
const MastheadElement = document.getElementById("masthead");
const ParallaxRoot = document.querySelector('.StarDaysMasthead-background-container');
if (ParallaxRoot) {
    const ParallaxBase = ParallaxRoot.querySelector('.StarDaysMasthead-background-container-moon');
    const ParallaxLayer = ParallaxRoot.querySelector('.StarDaysMasthead-background-container-layer');
    const ParallaxStars = ParallaxRoot.querySelector('.MastheadStars-parallax-stars');
    const KeyDeltaFactor = -0.2;
    const DriftIngressTime = 1000;
    const DriftPauseTime = 2500;
    const DriftDecayTime = 5000;
    const DriftResumeTime = DriftPauseTime + DriftDecayTime;
    const MotionScaleFactor = 5.0;
    let syncFactor = 0;
    let mouseX, mouseY;
    let lastMouseEvent = 0;
    let frameTimestamp = 0;

    function calcDriftFactor() {
        const ms = Date.now() % 30000;
        const progress = ms / 30000.0;
        const rad = progress * 2 * Math.PI;
        const driftX = Math.cos(rad);
        const driftY = Math.sin(rad) * 0.5625;

        return {driftX, driftY}
    }

    function sync(timestamp) {
        if (frameTimestamp < timestamp) {
            const elapsed = timestamp - frameTimestamp;
            frameTimestamp = timestamp;

            if (window.PageComponents && window.PageComponents.isDesktopUp()) {
                const timeSinceLastMouseEvent = Date.now() - lastMouseEvent;

                let deltaX = 0;
                let deltaY = 0;
                const {driftX, driftY} = calcDriftFactor();
                if (timeSinceLastMouseEvent < DriftResumeTime) {
                    const mouseMax = MastheadElement.getBoundingClientRect().width / 2;
                    if (timeSinceLastMouseEvent > DriftPauseTime) {
                        syncFactor = 1.0 - (timeSinceLastMouseEvent - DriftPauseTime) / DriftDecayTime;
                    } else {
                        if (syncFactor < 1.0) {
                            syncFactor += (elapsed / DriftIngressTime);
                            if (syncFactor > 1.0) syncFactor = 1.0;
                        }
                    }
                    deltaX = lerp(driftX, (mouseX / mouseMax), easeInOutSine(syncFactor));
                    deltaY = lerp(driftY, (mouseY / mouseMax), easeInOutSine(syncFactor));
                } else {
                    deltaX = driftX;
                    deltaY = driftY;
                }

                deltaX *= MotionScaleFactor;
                deltaY *= MotionScaleFactor;

                ParallaxBase.style.transform = `translate(${2+ KeyDeltaFactor * deltaX * 0.4}%, ${KeyDeltaFactor * deltaY * 0.4}%)`;
                ParallaxLayer.style.transform = `translate(${5 + KeyDeltaFactor * deltaX}%, ${KeyDeltaFactor * deltaY }%)`;
                ParallaxStars.style.transform = `translate(${KeyDeltaFactor * deltaX * 0.1}%, ${KeyDeltaFactor * deltaY * 0.1 - 10}%)`;
            } else {
                ParallaxBase.style.transform = null;
                ParallaxLayer.style.transform = null;
                ParallaxStars.style.transform = null;
            }

            update();
        }
    }

    function update() {
        requestAnimationFrame(sync);
    }

    function syncMouse(e) {
        const rect = MastheadElement.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.width * .28125;
        mouseX = e.clientX - centerX;
        mouseY = e.clientY - centerY;
        lastMouseEvent = Date.now();
    }
    MastheadElement.addEventListener("mousemove", syncMouse);

    document.addEventListener('DOMContentLoaded', update);
}



function swap() {
    let unrevealed = document.getElementById("unrevealed-text");
    let revealed = document.getElementById("revealed-text");

    unrevealed.style.display = 'none';
    revealed.style.display= 'block';
}

const ANIMATION_TIME = 5;

let active = false;
let open = false;

let animation_id = null;
let height_modifier = 0.47;
let current_expand;
clearInterval(animation_id);
const top = document.getElementById("top");
const envelope = document.getElementById("envelope-object");
const cards = envelope.querySelector(".EnvelopeCards");
const cover = envelope.querySelector(".EnvelopeCover");
const back = envelope.querySelector(".EnvelopeBack");
const seal = document.getElementById("seal");
const part_open_scale = 0.45;
const button = document.getElementById("envelope-controller");
const downloader = document.getElementById("envelope-downloader");
let shifted = false;

setHeightModifier();

function setHeightModifier() {
    let w = window.innerWidth;

    if(w < 768) {
        height_modifier = 0.5;
    } else if(w < 1280) {
        height_modifier = 0.44;
    } else {
        height_modifier = 0.435;
    }
}

function modify() {

    setHeightModifier();

    let height = top.offsetHeight * height_modifier;
    let scale = getTransformNumber(top.style.transform, 1, "scaleY(", ")");
    top.style.transform = "translate( 0, " + ((1-scale) * height) + "px) scaleY(" + scale + ")";
}

function getTransformNumber(transform, def, search, search_end) {
    let beginning = -1;
    let end = -1;

    beginning = transform.lastIndexOf(search);

    if(beginning === -1) return def;

    end = transform.indexOf(search_end, beginning + search.length);

    if(end === -1) return def;

    return Number(transform.substring(beginning + search.length, end));

}

function getTransformNumberTail(transform, def, search_end) {
    let end = -1;

    end = transform.indexOf(search_end);

    if(end === -1) return def;

    return Number(transform.substring(0, end));

}

const getAnchor = (element) => {
    const box = element.getBoundingClientRect();

    switch (element.getAttribute('data-anchor')) {
        case 'bottom':
            return box.bottom;
        case 'middle':
        default:
            return box.top + (box.height / 2);
    }
}

function if_hover() {
    if(!shifted) {

        const midline = getAnchor(envelope);

        if (midline > 0 && midline < window.innerHeight) {
            hoverEnvelope();
            shifted = true;
        }
    }
}

function hoverEnvelope() {
    let height = top.offsetHeight * height_modifier;
    let open_rate = 0.005;
    let opacity = Number(seal.style.opacity);
    if(!opacity) {
        opacity = 1;
    }

    let scale = getTransformNumber(top.style.transform, 1, "scaleY(", ")");

    clearInterval(animation_id);
    animation_id = setInterval(fade, ANIMATION_TIME);

    function fade() {
        if(opacity <= 0) {
            clearInterval(animation_id);
            animation_id = setInterval(moveFlap, ANIMATION_TIME);
            seal.style.display = "none";
        } else {
            opacity -= 0.01;
            seal.style.opacity = "" + opacity;
        }
    }

    function moveFlap() {
        if(scale <= part_open_scale) {
            clearInterval(animation_id);
        } else {
            scale -= open_rate;
            open_rate *= 1.03;
            top.style.transform = "translate( 0, " + ((1-scale) * height) + "px) scaleY(" + scale + ")";
            cards.style.transform = "translate( 0, " + ((scale - 1) * height * 0.55) + "px)";
        }
    }
}

function openEnvelope() {
    envelope.style.animationPlayState = "paused";
    let scale = getTransformNumber(top.style.transform, part_open_scale, "scaleY(", ")");
    let height = top.offsetHeight * height_modifier;
    let cards_translate = getTransformNumber(cards.style.transform, - part_open_scale * 0.55 * height,
        "translate(0px, ", "px");
    let open_rate = 0.045;

    clearInterval(animation_id);

    animation_id = setInterval(fullyOpen, ANIMATION_TIME);

    function fullyOpen() {
        if(scale <= -1) {
            clearInterval(animation_id);
            active = false;
            open = true;
            animation_id = setInterval(slideDownEnvelope, ANIMATION_TIME);
        } else {
            scale -= open_rate;
            open_rate *= 0.98;
            top.style.transform = "translate( 0, " + ((1-scale) * height) + "px) scaleY(" + scale + ")";
            cards.style.transform = "translate( 0, " + (cards_translate + (scale - part_open_scale) * height * 0.05) + "px)";

            if(scale < 0) {
                top.style.zIndex = "0";
            }
        }

    }
}

function slideDownEnvelope() {
    let top_translate = getTransformNumber(top.style.transform, 2 * height,
        "translate(0px, ", "px");
    let height = top.offsetHeight * height_modifier;
    let envelope_translate = 0;
    let spd = 5;
    let opacity = 1;
    let opacity_speed = 0.005;

    clearInterval(animation_id);
    animation_id = setInterval(translate_envelope, ANIMATION_TIME);

    function translate_envelope() {
        if (envelope_translate >= 1200) {
            clearInterval(animation_id);
            animation_id = setInterval(modifyCards, ANIMATION_TIME / 10);
            top.style.display = "none";
            cover.style.display = "none";
            button.style.display = "none";
        } else {
            envelope_translate += spd;
            opacity -= opacity_speed;
            spd *= 1.05;
            opacity_speed *= 1.05;
            top.style.transform = "scaleY(-1) translateY(" + (envelope_translate - height * 2) + "px";
            cover.style.transform = "translateY(" + envelope_translate + "px)";
            back.style.transform = "translateY(" + envelope_translate + "px";
            seal.style.transform = "translateY(" + envelope_translate + "px";
            button.style.transform = "translateY(" + envelope_translate + "px";
            top.style.opacity = opacity + "";
            cover.style.opacity = opacity + "";
            back.style.opacity = opacity + "";
            button.style.opacity = opacity + "";

        }
    }

}

function modifyCards() {

    const sticker_nova = cards.querySelector(".EnvelopeCards-sticker-nova");
    const card_hexnote = cards.querySelector(".EnvelopeCards-share-hex-grid");
    const sticker_winged = cards.querySelector(".EnvelopeCards-sticker-winged");
    const sticker_birde = cards.querySelector(".EnvelopeCards-sticker-birdie");
    const card_1999 = cards.querySelector(".EnvelopeCards-share-1999-grid");
    let scale = 1;
    let transform_part = 0;
    let scale_spd = 0.02;
    let transform_spd = 0.05;

    clearInterval(animation_id);
    animation_id = setInterval(scale_stickers, ANIMATION_TIME);

    function scale_stickers() {
        if (scale > 1.4) {
            clearInterval(animation_id);
            sticker_nova.classList.add("is-active");
            card_hexnote.classList.add("is-active");
            sticker_winged.classList.add("is-active");
            sticker_birde.classList.add("is-active");
            card_1999.classList.add("is-active");
            downloader.style.display = "inline-flex";
        } else {
            scale += scale_spd;
            transform_part += transform_spd;
            scale_spd *= 0.955;
            transform_spd *= 0.955;

            sticker_nova.style.scale = scale + "";
            card_hexnote.style.scale = scale * 0.8 + "";
            sticker_winged.style.scale = scale + "";
            sticker_birde.style.scale = scale + "";
            card_1999.style.scale = scale * 0.8 + "";
            sticker_nova.style.transform = "translate(" + transform_part * - 30 + "%, " + transform_part * -10 + "%)";
            card_hexnote.style.transform = "translate(" + transform_part * 10 + "%, " + transform_part * - 12 + "%)";
            card_1999.style.transform = "translate(" + transform_part * - 75 + "%, " + transform_part * 50 + "%)";
            sticker_winged.style.transform = "translate(" + transform_part * - 0 + "%, " + transform_part * 55 + "%)";
            sticker_birde.style.transform = "translate(" + transform_part * 100 + "%, " + transform_part * 100 + "%)";
            button.style.transform = "translateY(" + transform_part * 500 + "%)";

        }
    }
}

if(button) {

    window.addEventListener("resize", modify);
    window.addEventListener('resize', if_hover);
    window.addEventListener('scroll', if_hover);
    window.addEventListener('mousedown', teleport);
    if_hover();
    button.addEventListener('click', swap);
    button.addEventListener('click', function() {
        envelope.addEventListener('animationiteration', openEnvelope);
    });

    envelope.style.animationName = "jump";

    // Run when the DOM is ready
    // Check if `window.onload` has already fired

    if (document.readyState === "complete") {
        initShareCards(); // Page is already fully loaded, run immediately
    } else {
        window.onload = initShareCards; // Otherwise, wait for `window.onload`
    }
}

const fall_star = document.getElementsByClassName("falling-star");

function setScaleModifier() {
    let w = window.innerWidth;
    let scales = [0.05, 0.1, 0.2];

    if (w < 768) {
        return scales[0];
    } else if(w < 1280) {
        return scales[1];
    } else {
        return scales[2];
    }

}

function teleport(e) {
    let x = e.clientX;

    if(x > window.innerWidth) {
        x = window.innerWidth;
    }

    let y = e.clientY + window.scrollY + 5;

    for(let i = 0; i < fall_star.length; i++) {
        let element = fall_star.item(i);

        element.style.left = x + (Math.random() - 3) * element.width * setScaleModifier() + "px";
        element.style.top = e.clientY + "px";
        element.style.position = "fixed";

        element.style.animationName = "fall";
        element.style.display = "block";
        element.style.animationDelay = Math.random() * 0.75 + "s";
        swap_star(element);

    }

    window.removeEventListener('mousedown', teleport);
    window.addEventListener('mouseup', hide);
    window.addEventListener('mousemove', hide);
}

function hide() {
    window.removeEventListener('mousemove', hide);
    window.removeEventListener('mouseup', hide);
    window.addEventListener('mousedown', teleport);

    for(let i = 0; i < fall_star.length; i++) {
        let element = fall_star.item(i);

        element.style.display = "none";

    }
}

function getRandomInt(max) {
    return Math.floor(Math.random() * max);
}

function swap_star(elem) {

    elem.style.filter = "hue-rotate(" + getRandomInt(360) + "deg)";
}



const imagesToGenerate = document.querySelectorAll('.EnvelopeCards-hexnote, .EnvelopeCards-1999note'),
    $container = document.getElementById( 'share-content-grid-hex' ); // Track items
let imagesProcessed = 0;

async function generateImage(element) {
    try {
        const canvas = await html2canvas(element, {
            backgroundColor: "#30374B",
            useCORS: true,
            allowTaint: true,
            scale: 1
        });
        return canvas.toDataURL('image/png', 0.9 );
    } catch (error) {
        console.error('Error generating image:', error);
    }
}


async function initializeShareCard(cardElement) {
    const cardId = cardElement.getAttribute('data-sharable-view');
    const $target = document.querySelector(`[data-sharable-view="${cardId}"]`);

    try {
        const dataUrl = await generateImage(cardElement);

        const img = document.createElement('img');
        img.src = dataUrl;
        img.alt = '';
        $target.querySelector('figure').appendChild(img);

        imagesProcessed++;

        // If this is the last image, set a class or trigger an event
        if (imagesProcessed === imagesToGenerate.length) {
            $container.classList.add('images-loaded');
        }

        // Attach download event
        downloader.addEventListener('click', (event) => {

            if(open) {
                event.preventDefault();
                DownloadJS(dataUrl, `star-days-valentine-2026-${cardId}.png`, 'image/png');
            }
        });
    } catch (error) {
        console.error(`Failed to generate image for ${cardId}:`, error);
        $container.classList.add('loading-error');
    }
}

// Initialize all share cards
function initShareCards() {
    imagesToGenerate.forEach((card) => initializeShareCard(card));
}
